import React from "react";
import { Container, Col, Row, Button } from "react-bootstrap";
import { Header, Footer } from "../../Container";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

function ClientDetails() {
  const location = useLocation();
  const { data } = location.state.params;
  return (
    <Container fluid="true">
      <Header type="recruiter" />
      <Container >
        <Link to="/"><Button variant="outline-primary btn-back-main mt-4">Back</Button></Link>
        <Col className="p-0 rounded shadow-sm p-3 mb-5 bg-white mt-4">
          <Col>
            <Row>
              <Col>
                <h4 className="title"> Name of the Company</h4> <hr />
                <h6 >{data.user.fullname}</h6>
                <img
                  style={{ height: "100px", width: "100px", borderRadius: '3.25rem' }}
                  src={data?.client_image}
                  alt="Profile"

                />
              </Col>
            </Row>
            <Col><hr />
              <h4 className="title">Division</h4>
              <h6>{data.industry}</h6>
            </Col>

            <Col><hr />
              <h4 className="title">Size of Company</h4>
              <h6>{data.company_size}</h6>
            </Col>

            <Col><hr />
              <h4 className="title">State & City</h4>
              <h6>{data?.user?.state?.name}  {data?.user?.city?.name} </h6>

            </Col>
            <Col><hr />
              <h4 className="title">Point of Contact</h4>
              <p style={{ fontSize: "18px", fontWeight: "bold" }}>Name:  <h6>{data.first_name} {data.last_name}</h6> </p>
              <p style={{ fontSize: "18px", fontWeight: "bold" }}>Title: <h6>{data.title}</h6></p>
              <p style={{ fontSize: "18px", fontWeight: "bold" }}>Email: <h6>{data.email}</h6></p>
              <p style={{ fontSize: "18px", fontWeight: "bold" }}>Phone Number:   <h6>{data.phone}</h6></p>
            </Col>
          </Col>
        </Col>
      </Container>
      <Footer />
    </Container>
  );
}

export default ClientDetails;
